import { render } from "./SectionGeneric.vue?vue&type=template&id=7d861336"
import script from "./SectionGeneric.vue?vue&type=script&lang=ts"
export * from "./SectionGeneric.vue?vue&type=script&lang=ts"
script.render = render

export default script